import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';

@Component({
    selector: 'app-payment-methods-slide',
    templateUrl: './payment-methods-slide.component.html',
    styleUrls: ['./payment-methods-slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodsSlideComponent implements OnChanges {
    @Output() public selectMethod: EventEmitter<System> = new EventEmitter<System>();
    @Input() public systems: Array<System> = [];
    @Input() public systemsQuotations: { [system: string]: number } = {};
    public orderedSystemByAmount: any = [];
    public notShowMatDialog: boolean = false;

    public constructor(private changeDetectorRef: ChangeDetectorRef) {}

    public ngOnChanges(): void {
        this.orderSystemsByAmount();
        this.changeDetectorRef.detectChanges();
    }

    private orderSystemsByAmount(): void {
        this.orderedSystemByAmount = [];
        this.systems.forEach((key) => {
            this.orderedSystemByAmount.push({ system: key, amount: this.systemsQuotations[key.id] });
        });
        this.orderedSystemByAmount = this.orderedSystemByAmount.sort((a: any, b: any) => a.amount - b.amount);
        this.changeDetectorRef.detectChanges();
    }

    public receiveEvent($event: any): void {
        this.notShowMatDialog = $event;
    }
}
